import "./PaperBlog.css";

export default function PaperBlog() {
  return (
    <>
      <div className="TirthankarArticle-paper">
        <section id="TirthankarArticle-section">
          <h1>
            The City<span className="TirthankarArticle-embellish"> of </span>
            Milwaukee
          </h1>
          <div className="TirthankarArticle-by-box">
            <h2 className="TirthankarArticle-by">
              January 1, 1801 • River West
            </h2>
          </div>
          <div className="TirthankarArticle-columns">
            <p>
              <span>One</span> Walter Cronkite died for your sins Andy Carvin
              hashtag Zite linkbait hyperlocal, The Daily startups Wikipedia
              filters Kindle Single future of narrative & how to avoid them
              social media. This Week in Review 5 praise erasers & how to avoid
              them social media.
            </p>
            <p>
              <span>Two</span> app but what's the business model bringing a tote
              bag to a knife fight Dayton for under $900 a day engagement
              Foursquare free as in beer hyperlocal Mozilla future of narrative
              information wants to be free paywall bot cancel my subscription
              Gutenberg location-based SEO, serendipity tools open of innocence
              net neutrality 5 praise erasers & how to avoid them Gutenberg
              parenthesis David Cohn 5% corruption.
            </p>
            <p>
              <span>Three</span> News Challenge cancel my subscription
              horse-race coverage aggregation Dayton for under $900 a day net
              neutrality 5% corruption Kindle Single experiment, future of
              narrative discuss the notion of the public fourth estate media
              diet hackgate DocumentCloud, Buttry Frontline shoot a photo
              curmudgeon he said she said Django the power of the press belongs
              to the person who owns one.
            </p>
            <blockquote className="TirthankarArticle-quote">
              "Buttry Frontline shoot a photo curmudgeon. He said she said
              Django, knows more than CNN leaves in data visualization dingbat.
              Lippmann WSJ."
            </blockquote>
            <p>
              <span>Four</span> across the wire the medium is the massage
              ProPublica Journal Register TweetDeck CNN leaves it there data
              visualization dingbat the audience knows more than I do paywall,
              explainer filters Storify cops beat Walter Lippmann WSJ CPC RT
              anonymity the power of the press belongs to the person who owns
              one, David Foster Wallace the notion of the public Snarkmarket
              hyperlocal The Work of Art in the Age of Mechanical Reproduction
              Fuego Twitter topples dictators Clay Shirky.
            </p>
            <p>
              <span>Five</span> Week in Review newsroom cafe gamification
              engagement Jeff Jarvis prostate explainer Django The Printing
              Press as an Agent of Change shoot a photo collaboration should
              isn't a business model, Lucius Nieman syndicated Alberto Ibarguen
              monetization tabloid Neil Postman a giant stack of newspapers that
              you'll never read Lucius Nieman masthead reporting privacy, shoot
              a video Jeff Jarvis prostate Romenesko engagement learnings
              mathewi hyperlocal free as in beer.
            </p>
            <p>
              <span>Six</span> what you do best and link to the rest column-inch
              he said she said Does my "yes, but" look big in this corner
              office? startups dingbat Does my "yes, but" look big in this
              corner office? WordPress cancel my subscription Aron Pilhofer
              community, Nick Denton commons-based peer production synergize
              every dog loves food Lucius Nieman Frontline Jeff Jarvis Google
              News The Weekender shoot a photo Knight News Challenge, filters
              Ushahidi RSS Arab spring YouTube dingbat horse-race coverage
              Gawker plagiarism.
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
